<template>
  <el-menu-item
    v-if="menuItem.isRoot"
    :index="menuItem.path">
    <svg-icon 
      v-if="menuItem.meta && menuItem.meta.icon" 
      :icon-class="menuItem.meta.icon" />
    <a role="button" slot="title">{{menuItem.meta.title}}</a>
  </el-menu-item>
  <el-submenu
    v-else-if="!menuItem.isRoot && menuItem.children && menuItem.children.length"
    :index="menuItem.path"
    popper-class="menu-popper">
    <template slot="title">
      <svg-icon 
        v-if="menuItem.meta && menuItem.meta.icon" 
        :icon-class="menuItem.meta.icon" />
      <span>{{menuItem.meta.title}}</span>
    </template>
    <Items 
      v-for="item in menuItem.children" 
      :key="item.path" 
      :menu-item="item" />
  </el-submenu>
</template>

<script>
import SvgIcon from '../../../components/SvgIcon.vue';
export default {
  components: { SvgIcon },
  name: 'Items',
  data () {
    return {
    }
  },
  props: {
    menuItem: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/Items.vue